// extracted by mini-css-extract-plugin
module.exports = {"link":"breadcrumbLinks__link","title":"breadcrumbLinks__title"};